const designSystemColors = {
  generalButtons: "#E04F28",
  secondaryButtons: "#022166",
  textGeneralButtons: "#FFF",
  disabledButtons: "#D5D7D9",
  cancelButtons: "#4A5157",
  iconBlue: "#2A56A5",
  blues: {
    b600: "#25407d",
  },

  gray700: "#262626",

  borderBlue: "#D1E9FF",
  lightBlue: "#F0F7FF",

  textDark: "#000",
  sucessColor: "#52c41a",
  errorColor: "#b81414",
  warningColor: "#faad14",
  infoColor: "#5188F4",
  activateGreen: "#228B22",
  textDescription: "#393D42",
  grayChart: "#8c8c8c",
  grayTitle: "#434343",
  backgrounds: {
    lightGray: "#FAFAFA",
  },
  red600: "#c53030",

  background: "#FFF",
  border: {
    input: "#E8E8E9",
    modalDivider: "#D9D9D9",
    lightGray: "#bfbfbf",
  },
  backgroundGray: "#F0F0F0",
};

export default designSystemColors;
